<template>
  <div>
    <h1 :class="$style.pageTitle">車両作成</h1>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form-vehicle />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormVehicle from '../../../components/FormComponents/Vehicle'

export default {
  components: {
    FormVehicle,
  },
}
</script>

<style lang="scss" module>
@import '@/assets/styles/mixins.scss';
</style>
